import { useAsync } from 'react-use';
import { Climate as GeographyClimate } from '@model/common';
import { ClimateComponent } from '@model/content';
import { ClimateType } from '@model/iceberg/geography';
import { useI18NextContext } from '@components/hooks';
import { Climate } from '@components/climate';
import { getHero } from '@components/util';

export const ClimateDataContainer = ({ path, temperatures, rainfall, sunshine }: ClimateComponent) => {
  const t = useI18NextContext();

  const { value: hero } = useAsync(async () => {
    return await getHero({ path });
  }, [path]);

  const climate: Array<GeographyClimate> = [
    {
      degrees: true,
      icon: 'mhi-temperature',
      months: temperatures,
      title: t('common__label--temperature'),
      type: ClimateType.TEMPERATURE
    },
    {
      degrees: false,
      icon: 'mhi-sun',
      months: rainfall,
      title: t('common__label--rainfall'),
      type: ClimateType.RAINFALL
    },
    {
      degrees: false,
      icon: 'mhi-sun',
      months: sunshine,
      title: t('common__label--sunshine'),
      type: ClimateType.SUNSHINE
    }
  ];

  const imgSrc = hero?.images && hero?.images.length ? hero?.images[0] : '';
  return <Climate climate={climate} image={imgSrc} />;
};
